import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "course-content" }
const _hoisted_2 = { class: "course-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "course-progress-row" }
const _hoisted_5 = { class: "progress-wrapper" }
const _hoisted_6 = { class: "progress-text" }
const _hoisted_7 = {
  key: 0,
  class: "certificate-btn"
}

import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Enrollment from '../../../api/v2/models/enrollment'
import { checkMobile } from '../../utils/utils'
import { footerState } from '../../stores/footer'


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseMy',
  props: {
    enrollment: {}
  },
  setup(__props: any) {

const CourseDefaultImg = require("../../../../images/course-default.png").default || require("../../../../images/course-default.png")

const route = useRoute()
const router = useRouter()

// Props
const props = __props

// Reactive Data
const isMobile = ref(checkMobile())
const size = computed(() => isMobile.value ? 70 : 80)

// Computed
const courseImageUrl = computed(() => props.enrollment.course?.image?.url || CourseDefaultImg)
const hasCertificate = computed(() => !!props.enrollment.certificateUrl)

// Functions
function saveNavigationPath() {
  sessionStorage.setItem('previousPage', route.path)
  router.push(`/classroom/my-courses/${props.enrollment.course.id}`)
}

// Created logic
footerState.setFooterDefault()

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    key: __props.enrollment.id,
    cytag: "course-item",
    class: "course-my-item pa-3"
  }, [
    _createCommentVNode(" Left: Image "),
    _createElementVNode("div", {
      class: "course-image-wrapper",
      onClick: saveNavigationPath
    }, [
      _createVNode(_component_v_img, {
        width: size.value,
        height: size.value,
        src: courseImageUrl.value,
        class: "rounded",
        cover: ""
      }, null, 8 /* PROPS */, ["width", "height", "src"])
    ]),
    _createCommentVNode(" Right: Text and Progress "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" Row 1: Title and Description "),
      _createElementVNode("div", {
        class: "course-text",
        onClick: saveNavigationPath
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.enrollment.course.name), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "course-description",
          innerHTML: __props.enrollment.course.description
        }, null, 8 /* PROPS */, _hoisted_3)
      ]),
      _createCommentVNode(" Row 2: Progress Bar and Certificate "),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_progress_linear, {
            "model-value": __props.enrollment.progressPercent,
            height: "20",
            color: "primary",
            rounded: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(__props.enrollment.progressPercent) + "%", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model-value"])
        ]),
        (hasCertificate.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                size: "small",
                color: "success",
                href: __props.enrollment.certificateUrl,
                target: "_blank",
                class: "text-none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "small",
                    class: "me-1"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-certificate", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[1] || (_cache[1] = _createTextVNode(" 修了証 ", -1 /* CACHED */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["href"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})